var map = {
	"./player1.png": 2149,
	"./player10.png": 5665,
	"./player11.png": 7400,
	"./player12.png": 1891,
	"./player13.png": 6682,
	"./player14.png": 3730,
	"./player15.png": 1932,
	"./player16.png": 2567,
	"./player17.png": 9550,
	"./player18.png": 8937,
	"./player19.png": 2032,
	"./player2.png": 3998,
	"./player20.png": 7484,
	"./player21.png": 6581,
	"./player22.png": 9230,
	"./player23.png": 7543,
	"./player24.png": 6024,
	"./player25.png": 241,
	"./player26.png": 74,
	"./player27.png": 7651,
	"./player28.jpeg": 1561,
	"./player28.png": 3636,
	"./player29.png": 9933,
	"./player3.png": 3367,
	"./player30.png": 3751,
	"./player31.png": 4254,
	"./player32.png": 2085,
	"./player33.png": 9820,
	"./player34.png": 7219,
	"./player35.png": 9277,
	"./player36.png": 2737,
	"./player37.png": 1608,
	"./player38.png": 6415,
	"./player39.png": 1222,
	"./player4.png": 1848,
	"./player40.png": 1994,
	"./player41.png": 7555,
	"./player42.png": 1944,
	"./player43.png": 3073,
	"./player44.png": 4590,
	"./player45.png": 4087,
	"./player46.png": 156,
	"./player47.png": 2421,
	"./player48.png": 1042,
	"./player49.png": 1547,
	"./player5.png": 6465,
	"./player50.png": 4917,
	"./player51.png": 9004,
	"./player52.png": 1655,
	"./player53.png": 9166,
	"./player54.png": 5905,
	"./player55.png": 2040,
	"./player56.png": 8899,
	"./player57.png": 1146,
	"./player6.png": 7482,
	"./player7.png": 6339,
	"./player8.png": 420,
	"./player9.jpeg": 9026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7226;